import React, { useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useDesktopColors } from '@/constants/residents/desktop/color';

interface EmptyStateViewProps {
  icon: React.ReactNode;
  title: string;
  message: string;
}

export const EmptyStateView: React.FC<EmptyStateViewProps> = ({ icon, title, message }) => {
  const DESKTOP_COLORS = useDesktopColors();
  const styles = useMemo(() => buildStyles(DESKTOP_COLORS), [DESKTOP_COLORS]);

  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        {icon}
      </View>
      <Text style={styles.title}>{title}</Text>
      <Text style={styles.message}>{message}</Text>
    </View>
  );
};

type DesktopColors = ReturnType<typeof useDesktopColors>;

const buildStyles = (DESKTOP_COLORS: DesktopColors) => StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 32,
    paddingHorizontal: 16,
  },
  iconContainer: {
    marginBottom: 16,
  },
  title: {
    fontSize: 16,
    fontWeight: '700',
    color: DESKTOP_COLORS.TEXT_PRIMARY,
    marginBottom: 8,
    textAlign: 'center',
  },
  message: {
    fontSize: 14,
    color: DESKTOP_COLORS.TEXT_TERTIARY,
    textAlign: 'center',
    lineHeight: 20,
  },
});
